import {actionTypes} from '../actions';

export const reducer = (sessionState, action) => {
  const {type, value} = action;
  switch (type) {
    case actionTypes.INIT: {
      return {
        ...sessionState,
        ...value,
      };
    }

    case actionTypes.ROUTE_CHANGE: {
      return {
        ...sessionState,
        nav_history: [...sessionState.nav_history, value],
      };
    }

    case actionTypes.APP_IS_LOADING: {
      return {
        ...sessionState,
        app_loading: true,
      };
    }

    case actionTypes.APP_DONE_LOADING: {
      return {
        ...sessionState,
        app_loading: false,
      };
    }

    case actionTypes.SERVICE_REQUEST_UPDATE: {
      const {rob_id, license, status, rob_status, rob_invoicing_status} = value;
      return {
        ...sessionState,
        serviceRequestUpdate: {
          ...sessionState.serviceRequestUpdate,
          [rob_id]: {
            timestamp: new Date(),
            license,
            status,
            rob_status,
            rob_invoicing_status,
          },
        },
      };
    }

    case actionTypes.SHOW_LOGOUT_DIALOG: {
      return {
        ...sessionState,
        show_logout_dialog: value,
      };
    }

    case actionTypes.SET_SHOW_DRAWER: {
      return {
        ...sessionState,
        show_drawer: value,
      };
    }

    default: {
      return sessionState;
    }
  }
};
